import * as React from 'react';

export const IconDownload = () => (
  <svg
    fill='none'
    height='16'
    viewBox='0 0 16 16'
    width='16'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.076 0.888672C7.86638 0.888672 7.66534 0.971954 7.51711 1.1202C7.36889 1.26844 7.28561 1.4695 7.28561 1.67915V9.2085L3.95292 5.87116C3.79804 5.71654 3.5881 5.6298 3.36927 5.63C3.15044 5.6302 2.94065 5.71733 2.78605 5.87222C2.63146 6.02712 2.54472 6.23709 2.54492 6.45595C2.54512 6.6748 2.63225 6.88461 2.78712 7.03923L7.45139 11.7094C7.53278 11.7911 7.63046 11.8548 7.73807 11.8962C7.84569 11.9377 7.96083 11.956 8.076 11.95C8.19117 11.956 8.30629 11.9376 8.4139 11.8961C8.5215 11.8547 8.61919 11.791 8.70062 11.7094L13.3649 7.03923C13.5198 6.88461 13.6069 6.6748 13.6071 6.45595C13.6073 6.23709 13.5205 6.02712 13.366 5.87222C13.2114 5.71733 13.0016 5.6302 12.7827 5.63C12.5639 5.6298 12.354 5.71654 12.1991 5.87116L8.86639 9.2085V1.67915C8.86639 1.4695 8.78312 1.26844 8.63489 1.1202C8.48667 0.971954 8.28563 0.888672 8.076 0.888672Z'
      fill='#6C757D'
    />
    <path
      d='M2.54541 14.3217C2.54541 14.1121 2.62868 13.911 2.77691 13.7628C2.92514 13.6145 3.12618 13.5312 3.3358 13.5312H12.813C13.0175 13.5388 13.211 13.6253 13.353 13.7726C13.495 13.9199 13.5743 14.1166 13.5743 14.3212C13.5743 14.5258 13.495 14.7225 13.353 14.8698C13.211 15.0171 13.0175 15.1036 12.813 15.1111H3.3358C3.12636 15.1111 2.92548 15.028 2.77729 14.88C2.62909 14.732 2.54569 14.5312 2.54541 14.3217V14.3217Z'
      fill='#6C757D'
    />
  </svg>
);
